<template>
    <div class="w-full" :class="$attrs.class">
        <input-label
            v-if="label"
            :value="label"
        />
        <select
            ref="input"
            v-model="modelValue"
            v-bind="$attrs"
            class="rounded border border-gray-300 px-4 py-2.5 text-xs w-full"
        >
            <slot />
        </select>
        <input-error :message="error"/>
    </div>
</template>

<script>
import InputLabel from "@/Components/Label";
import InputError from "@/Components/InputError";

export default {
    components: {
        InputLabel,
        InputError,
    },
    inheritAttrs: false,
    props: {
        modelValue: [String, Number, Boolean],
        label: String,
        error: Array,
    },
    watch: {
        selected(selected) {
            this.$emit('input', selected)
        },
    },
    methods: {
        focus() {
            this.$refs.input.focus()
        },
        select() {
            this.$refs.input.select()
        },
    },
}
</script>
